import { RtbfRefStatus, RtbfStatus } from "app/areas/user/gdpr/rtbfStatus.model";
import { IAction } from "../IAction";


export class SendRtbfStatusRequest implements IAction {
    static $inject = ['$uibModal', 'applicationInstance', 'Auth', 'RtbfStatus'];
    constructor(private $uibModal, private applicationInstance, private Auth, private RtbfStatus){}


    execute(): void {
        return this.$uibModal.open({
            templateUrl: 'areas/action/gdpr/sendRtbfStatusRequestModal.html',
            controller: SendRtbfStatusRequestModalController,
            controllerAs: 'ctrl',
            backdrop: false,
            resolve: {
                userFullName: () => this.applicationInstance.fullName,
                requestingUserId: () => this.Auth.user.userId,
                requestedUserId: () => this.applicationInstance.userId,
                applicationId: () => this.applicationInstance.applicationId
            }
        }).result;
    }

}

class SendRtbfStatusRequestModalController {
    public reason: string;
    public rtbfStatus: RtbfStatus;

    static $inject = ['$scope', 'dialogs', '$uibModalInstance', 'userFullName', 'requestingUserId', 'requestedUserId', 'applicationId', 'RtbfStatus']
    constructor(private $scope, private dialogs, private $uibModalInstance, private userFullName, private requestingUserId, private requestedUserId, private applicationId, private RtbfStatus){

    }

    sendRequestDataDeletion(){
        this.$scope.$broadcast('submitted', true);

        this.dialogs.confirm(
            'Confirm',
            `You are requesting to permanently delete the data for the user ${this.userFullName}. Are you sure?`
        ).result
        .then(() => {
            this.rtbfStatus = {
                requestingUserId: this.requestingUserId,
                requestedUserId: this.requestedUserId,
                statusId: RtbfRefStatus.Requested,
                dateRequested: new Date(Date.now()),
                reason: this.reason
            };

            this.RtbfStatus.save({ applicationId: this.applicationId }, this.rtbfStatus).$promise
                .then(() => {
                    this.dialogs
                        .notify('Success', `Your request to delete data for user ${this.userFullName} is confirmed.`);
                }, () => {
                    this.dialogs
                        .error('Error', 'Unable to request data deletion. Please try again later.')
                        .result;
                }).finally(() => {
                    this.$uibModalInstance.close();
                });
        });
    }

    close(){
        this.$uibModalInstance.dismiss();
    }
}